<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div class="grid" *ngIf="!carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12">

    <p-accordion
      id="accordion"
      [multiple]="false"
      (onOpen)="abrirAcordeon($event)"
    >
      <p-accordionTab
        header="{{ 'TIPOOCUPACION.LBL_TIPOOCUPACIONCONFIGURACION' | translate }}"
        [selected]="tabSeleccionado === 'TIPOCU'"
      >
        <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idFormulario" name="nomFormulario">
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'TIPOOCUPACION.LBL_TIPOOCUPACION' | translate }}</label>
                  <div *ngIf="!f.idTipoOcupacionConfiguracion.value">
                    <p-dropdown disableTab  id="idTipoOcupacion" name="nomTipoOcupacion" [options]="lisOcupaciones" filter="filter"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}" optionValue="value" optionLabel="label"
                                 formControlName="idTipoOcupacion"
                    ></p-dropdown>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoOcupacion.invalid">
                      {{ 'TIPOOCUPACION.LBL_TIPOOCUPACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                  <label *ngIf="f.idTipoOcupacionConfiguracion.value" class="falso-combo-texto">{{f.nombreTipoOcupacion.value}}</label>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'TIPOOCUPACION.LBL_INGRESOS' | translate}}" binary="true"
                            id="idIndicadorIngresos"
                            name="nomIndicadorIngresos"
                            formControlName="indicadorIngresos"></p-checkbox>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'TIPOOCUPACION.LBL_ACTIVOS' | translate}}" binary="true"
                            id="idIndicadorActivos"
                            name="nomIndicadorActivos"
                            formControlName="indicadorActivos"></p-checkbox>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'TIPOOCUPACION.LBL_NUMEROEMPLEADOS' | translate}}" binary="true"
                            id="idIndicadorNumeroEmpleados"
                            name="nomIndicadorNumeroEmpleados"
                            formControlName="indicadorNumeroEmpleados"></p-checkbox>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'TIPOOCUPACION.LBL_NIVELENDEUDAMIENTO' | translate}}" binary="true"
                            id="idIndicadorNivelEndeudamiento"
                            name="nomIndicadorNivelEndeudamiento"
                            formControlName="indicadorNivelEndeudamiento"></p-checkbox>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'TIPOOCUPACION.LBL_SECTOR' | translate}}" binary="true"
                            id="idIndicadorSector"
                            name="nomIndicadorSector"
                            formControlName="indicadorSector"></p-checkbox>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'TIPOOCUPACION.LBL_TIPOCONTRATO' | translate}}" binary="true"
                            (focusin)="inhabilitarcheckFondo()"
                            id="idIndicadorTipoContrato"
                            name="nomIndicadorTipoContrato"
                            formControlName="indicadorTipoContrato"></p-checkbox>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'TIPOOCUPACION.LBL_EMPLEADOR' | translate}}" binary="true"
                            id="idIndicadorEmpleador"
                            name="nomIndicadorEmpleador"
                            formControlName="indicadorEmpleador"></p-checkbox>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'TIPOOCUPACION.LBL_MANEJAACTIVIDADES' | translate}}" binary="true"
                            id="idIndicadorManejaActividades"
                            name="nomIndicadorManejaActividades"
                            formControlName="indicadorManejaActividades"></p-checkbox>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'TIPOOCUPACION.LBL_GENERO' | translate}}" binary="true"
                            id="idIndicadorGenero"
                            name="nomIndicadorGenero"
                            formControlName="indicadorGenero"></p-checkbox>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'TIPOOCUPACION.LBL_EDAD' | translate}}" binary="true"
                            id="idIndicadorEdad"
                            name="nomIndicadorEdad"
                            formControlName="indicadorEdad"></p-checkbox>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'TIPOOCUPACION.LBL_UNIDADPRODUCTIVA' | translate}}" binary="true"
                            id="idIndicadorUnidadProductiva"
                            name="nomIndicadorProductiva"
                            formControlName="indicadorUnidadProductiva"></p-checkbox>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                            id="idIndicadorHabilitado"
                            name="nomIndicadorHabilitado"
                            formControlName="indicadorHabilitado"></p-checkbox>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'TIPOOCUPACION.LBL_ANALIZAMOS' | translate}}" binary="true"
                            id="indicadorAnalizamos"
                            name="nomIndicadorAnalizamos"
                            formControlName="indicadorAnalizamos"></p-checkbox>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'TIPOOCUPACION.LBL_FLUJODIGITAL' | translate}}" binary="true"
                            (onChange)="inhabilitarChecks()"
                            id="indicadorFlujoDigital"
                            name="nomIndicadorFlujoDigital"
                            formControlName="indicadorFlujoDigital"></p-checkbox>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'TIPOOCUPACION.LBL_PAGADURIA' | translate}}" binary="true"
                            id="indicadorPagaduria"
                            name="nomIndicadorPagaduria"
                            formControlName="indicadorPagaduria"></p-checkbox>
              </div>

              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'TIPOOCUPACION.LBL_ASIGNAREJECUTIVO' | translate}}" binary="true"
                            *ngIf = "f.indicadorFlujoDigital.value"
                            id="indicadorAsignarEjecutivo"
                            name="nomIndicadorAsignarEjecutivo"
                            formControlName="indicadorAsignarEjecutivo"></p-checkbox>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'TIPOOCUPACION.LBL_FONDOPENSION' | translate}}" binary="true"
                            (focusin)="inhabilitarcheckContrato()"
                            id="indicadorFondoPension"
                            name="nomIndicadorFondoPension"
                            formControlName="indicadorFondoPension"></p-checkbox>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'TIPOOCUPACION.LBL_INDICADORTIPOOCUPACION' | translate}}" binary="true"
                            id="tipoOcupacion"
                            name="nomIndicadorTipoOcupacion"
                            formControlName="indicadorTipoOcupacion"></p-checkbox>
              </div>
              <div class="col-12">
                <div class="div-form">
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !f.indicadorFlujoDigital.value && !f.indicadorAnalizamos.value">
                    {{ 'TIPOOCUPACION.MSG_ERROR' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <div *ngIf="!guardando">
                  <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                  <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                          type="submit"
                          pButton></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>
            </div>
          </form>
      </p-accordionTab>
      <p-accordionTab
        header="{{ 'TIPOOCUPACION.LBL_CONFIGURACIONFLUJODIGITAL' | translate }}"
        [selected]="tabSeleccionado === 'FLUDIG'" *ngIf="tipOcupacion && tipOcupacion.indicadorFlujoDigital"
      >
        <app-flujos-creditos-digitales [tipOcupacion]="tipOcupacion" [flujoDigital]="canales.TIPOOCUPACION"></app-flujos-creditos-digitales>
      </p-accordionTab>

    </p-accordion>




  </div>
</div>


<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
